import axios from "../axios";
import api from "../api";

export const state = {
  prompts: {
    prompt1: '',
  },
}

export const mutations = {
  SET_AYELET_EMAILS_STATE (state, {key, data}) {
    state[key] = data;
  },
  SET_AYELET_EMAILS_PROMPT (state, {key, value}) {
    state.prompts[key] = value;
  },
}

export const actions = {
  async get_ayelet_emails_prompts ({ commit }) {
    try {
      commit('SET_REQ_STATUS', 'loading')
      const { data } = await axios.get(`${api.personalized_emails.settings}/prompts-ayelet`);
      commit('SET_AYELET_EMAILS_STATE', {key: 'prompts', data});
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  },

  async save_ayelet_emails_prompts ({ state, commit }) {
    try {
      commit('SET_REQ_STATUS', 'saving')
      await axios.put(`${api.personalized_emails.settings}/prompts-ayelet`, state.prompts);
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  },
}